import React, { useState } from "react";
import { staffQueue } from "../../api";
import Modal from "../../components/ui/Modal";
import { FormField, inputStyle, selectStyle, Btn } from "../../components/ui";
import toast from "react-hot-toast";

export default function ManualIssueModal({ open, onClose, onDone }) {
  const [form, setForm] = useState({
    patient_name:     "",
    patient_title:    "",
    patient_phone:    "",
    insurance_type:   "",
    reason_for_visit: "",
    priority:         "normal",
    language:         "en",
  });
  const [loading, setLoading] = useState(false);
  const [result,  setResult]  = useState(null);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    if (!form.patient_name.trim()) {
      toast.error("Patient name is required."); return;
    }
    if (!form.patient_phone.trim()) {
      toast.error("Phone number is required."); return;
    }
    setLoading(true);
    try {
      const { data } = await staffQueue.issueManual(form);
      setResult(data);
      toast.success(`Ticket issued: ${data.ticket_number}`);
    } catch (e) {
      const msg = e.response?.data?.error || e.response?.data?.detail || "Failed to issue ticket.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setForm({ patient_name: "", patient_title: "", patient_phone: "", insurance_type: "", reason_for_visit: "", priority: "normal", language: "en" });
    setResult(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Issue Manual Ticket" width="460px">
      {result ? (
        /* Success state */
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div style={S.successCard}>
            <div style={S.bigTicket}>{result.ticket_number}</div>
            <div style={S.successName}>{result.patient_name}</div>
            {result.current_station_name && (
              <div style={S.successStation}>→ {result.current_station_name}</div>
            )}
          </div>
          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={handleClose}>Close</Btn>
            <Btn onClick={() => { setResult(null); setForm({ patient_name: "", patient_title: "", patient_phone: "", insurance_type: "", reason_for_visit: "", priority: "normal", language: "en" }); }}>
              Issue Another
            </Btn>
          </div>
        </div>
      ) : (
        /* Form */
        <div style={S.form}>
          <FormField label="Patient Name" required>
            <input
              style={inputStyle}
              value={form.patient_name}
              onChange={e => set("patient_name", e.target.value)}
              placeholder="Full name"
              autoFocus
            />
          </FormField>

          <FormField label="Title (optional)">
            <select style={inputStyle} value={form.patient_title || ""} onChange={e => set("patient_title", e.target.value)}>
              <option value="">—</option>
              <option value="Mr">Mr</option>
              <option value="Madam">Madam</option>
            </select>
          </FormField>

          <div style={S.row2}>
            <FormField label="Phone Number" required>
              <input
                style={inputStyle}
                value={form.patient_phone}
                onChange={e => set("patient_phone", e.target.value)}
                placeholder="0XX XXX XXXX"
              />
            </FormField>
            <FormField label="Priority">
              <select style={selectStyle} value={form.priority} onChange={e => set("priority", e.target.value)}>
                <option value="normal">Normal</option>
                <option value="priority">Priority</option>
                <option value="emergency">Emergency</option>
              </select>
            </FormField>
          </div>

          <div style={S.row2}>
            <FormField label="Insurance Type">
              <input
                style={inputStyle}
                value={form.insurance_type}
                onChange={e => set("insurance_type", e.target.value)}
                placeholder="e.g. NHIS, Cash"
              />
            </FormField>
            <FormField label="Language">
              <select style={selectStyle} value={form.language} onChange={e => set("language", e.target.value)}>
                <option value="en">English</option>
                <option value="tw">Twi</option>
              </select>
            </FormField>
          </div>

          <FormField label="Reason for Visit">
            <input
              style={inputStyle}
              value={form.reason_for_visit}
              onChange={e => set("reason_for_visit", e.target.value)}
              placeholder="e.g. Consultation, Lab test"
            />
          </FormField>

          <div style={S.footer}>
            <Btn variant="ghost" onClick={handleClose} disabled={loading}>Cancel</Btn>
            <Btn onClick={handleSubmit} disabled={loading || !form.patient_name.trim()}>
              {loading ? "Issuing…" : "Issue Ticket"}
            </Btn>
          </div>
        </div>
      )}
    </Modal>
  );
}

const S = {
  form:    { display: "flex", flexDirection: "column", gap: "14px" },
  row2:    { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" },
  footer:  { display: "flex", justifyContent: "flex-end", gap: "10px", paddingTop: "8px", borderTop: "1px solid var(--surface-border)", marginTop: "4px" },
  successCard: {
    background: "rgba(34,197,94,0.08)", border: "1px solid rgba(34,197,94,0.2)",
    borderRadius: "14px", padding: "28px",
    display: "flex", flexDirection: "column", alignItems: "center", gap: "6px",
    textAlign: "center",
  },
  bigTicket:      { fontSize: "52px", fontWeight: "800", color: "#22C55E", letterSpacing: "-1.5px", lineHeight: 1 },
  successName:    { fontSize: "18px", fontWeight: "600", color: "var(--text-primary)", marginTop: "8px" },
  successStation: { fontSize: "13px", color: "var(--text-secondary)" },
};
